<!-- 通用设置 -->
<template>
  <div class="transcoding">
    <div class="transCoding_header">
      <el-tabs v-model="activeName">
        <el-tab-pane label="转码模板" name="first"></el-tab-pane>
        <el-tab-pane label="常用分类" name="second"> </el-tab-pane>
        <el-tab-pane label="策略配置" name="third"></el-tab-pane>
      </el-tabs>
      <!-- 转码模版 -->
      <TranscodePage v-if="activeName=='first'"/>
      <!-- 常用分类 -->
      <CategoryPage v-else-if="activeName=='second'"/>
      <!-- 策略配置 -->
      <PolicyPage v-else-if="activeName=='third'"/>
    </div>
  </div>
</template>
<script>
import TranscodePage from './components/transcodePage.vue'
import CategoryPage from './components/categoryPage.vue'
import PolicyPage from './components/policyPage.vue'
export default {
  components: {
    TranscodePage,
    CategoryPage,
    PolicyPage
  },
  data () {
    return {
      activeName: 'first'
    }
  }
}
</script>

<style lang="less" >
 @import "../../../assets/css/transCode.less";
</style>
